import { useState } from 'react';

import { useCampaignActivity } from '@/api/campaign';
import { useInstantSearchState } from '@/components/InstantSearch';
import { getSolQueryParamsNewFromQueryState } from '@/components/InstantSearch/util/search-util';
import { usePageFilterContext } from '@/components/page';

import CampaignActivityTableContainer from './CampaignActivityTableContainer';
import CampaignFitScoringTable from './CampaignFitScoringTable';
import CampaignOverviewKPIMetrics from './CampaignOverviewKPIMetrics';
import CampaignOverviewNoData from './CampaignOverviewNoData';

const CampaignOverviewContent = () => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();
  const { queryState } = useInstantSearchState();
  const [scoreCampaignIds, setScoreCampaignIds] = useState<string[]>([]);

  const { totalResults } = useCampaignActivity(
    getSolQueryParamsNewFromQueryState(queryState),
    startDate,
    endDate,
    audience?.id,
  );

  // If there are no results and no filters were added, it's likely that the user has not connected
  // any ad vendors yet.
  if (totalResults === 0 && !queryState.filters?.length) {
    return <CampaignOverviewNoData />;
  }

  return (
    <>
      <CampaignOverviewKPIMetrics />
      <CampaignActivityTableContainer onScoreCampaigns={setScoreCampaignIds} />
      <CampaignFitScoringTable campaignIds={scoreCampaignIds} />
    </>
  );
};

export default CampaignOverviewContent;
